// src/stable/useStepActions.ts
import { useMemo } from "react";
import { makeStepId } from "../__internal__/activity/index.mjs";
import { useCoreActions } from "../__internal__/core/index.mjs";
import { useTransition } from "../__internal__/shims/index.mjs";
var useStepActions = () => {
  const coreActions = useCoreActions();
  const [pending] = useTransition();
  return useMemo(
    () => ({
      pending,
      stepPush(params, options) {
        const stepId = makeStepId();
        coreActions == null ? void 0 : coreActions.stepPush({
          stepId,
          stepParams: params,
          targetActivityId: options == null ? void 0 : options.targetActivityId
        });
      },
      stepReplace(params, options) {
        const stepId = makeStepId();
        coreActions == null ? void 0 : coreActions.stepReplace({
          stepId,
          stepParams: params,
          targetActivityId: options == null ? void 0 : options.targetActivityId
        });
      },
      stepPop(options) {
        coreActions == null ? void 0 : coreActions.stepPop({
          targetActivityId: options == null ? void 0 : options.targetActivityId
        });
      }
    }),
    [
      coreActions == null ? void 0 : coreActions.stepPush,
      coreActions == null ? void 0 : coreActions.stepReplace,
      coreActions == null ? void 0 : coreActions.stepPop,
      pending
    ]
  );
};
export {
  useStepActions
};
